import { FC } from 'react'

import clsx from 'clsx'

import { AppIcon } from '../app-icon'
import { AllIcons } from '../app-icon/types'
import { Paper } from '../paper'

import s from './styles.module.scss'

export interface ItemResult {
  image?: string
  title?: string
  subTitle?: string
  code?: string
  isExcursions?: boolean
  showImage?: boolean
}

interface Props extends ItemResult {
  child?: ItemResult[]
  onSelect?: (data: ItemResult) => void
  soon?: boolean
  soonLabel?: string
}

export const SearchResultBlock: FC<Props> = (props) => {
  const {
    title,
    subTitle,
    code,
    child,
    image,
    onSelect,
    isExcursions,
    soon = false,
    soonLabel,
    showImage = true,
  } = props

  const handleClick = () => {
    if (!soon) {
      onSelect?.({ title: subTitle, subTitle: title, code })
    }
  }

  return (
    <Paper
      padding={[8, 16]}
      radius={isExcursions ? 16 : 20}
    >
      <div className={s.container}>
        <div
          className={clsx(s.header, soon && s.headerSoon)}
          onClick={handleClick}
        >
          {showImage && (
            <div className={s.left}>
              {image ? (
                <img
                  src={image}
                  className={clsx(s.image, isExcursions && s.excursionsImage)}
                  alt=""
                />
              ) : (
                <AppIcon
                  id={AllIcons.PIN}
                  className={s.icon}
                />
              )}
            </div>
          )}

          <div className={s.right}>
            <p className={clsx(s.title, soon && s.titleSoon)}>{subTitle}</p>

            {title && (
              <p className={clsx(s.subTitle, soon && s.subTitleSoon)}>
                {code ? `${title} • ${code}` : title}
              </p>
            )}

            {!title && code && (
              <p className={clsx(s.subTitle, soon && s.subTitleSoon)}>{code}</p>
            )}
          </div>

          {isExcursions && !soon && (
            <div className={s.icon}>
              <AppIcon id={AllIcons.ARROW_RIGHT} />
            </div>
          )}

          {soon && (
            <div className={s.soonWrapper}>
              <span className={clsx('medium-12', s.soonLabel)}>
                {soonLabel}
              </span>
            </div>
          )}
        </div>

        <div onClick={(e) => e.stopPropagation()}>
          {child?.map((item, index) => (
            <div
              key={index}
              className={s.itemChild}
              onClick={() =>
                onSelect?.({ ...item, subTitle: title, title: item.title })
              }
            >
              <div className={s.left}>
                <AppIcon
                  id={AllIcons.PLANE}
                  height={24}
                  width={24}
                />
              </div>

              <div className={s.right}>
                <p className={s.title}>{item?.title}</p>
                <p className={s.subTitle}>
                  {item?.subTitle} {item?.code && item?.subTitle && `•`}
                  {item?.code}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Paper>
  )
}
